import * as CryptoJS from "crypto-js";

export const encryptString = ({ str, secretKey }) => {
  const keyHex = CryptoJS.enc.Utf8.parse(
    secretKey ? secretKey : process.env.REACT_APP_SECRETKEY
  );
  const encrypted = CryptoJS.AES.encrypt(str, keyHex.toString());
  const encryptedStr = CryptoJS.enc.Base64.parse(encrypted.toString());

  return CryptoJS.enc.Hex.stringify(encryptedStr);
};

export const decryptString = ({ encryptedStr, secretKey }) => {
  const keyHex = CryptoJS.enc.Utf8.parse(
    secretKey ? secretKey : process.env.REACT_APP_SECRETKEY
  );
  const wordArray = CryptoJS.enc.Hex.parse(encryptedStr);
  const toDecrypt = CryptoJS.enc.Base64.stringify(wordArray);
  const decryptedStr = CryptoJS.AES.decrypt(toDecrypt, keyHex.toString());

  return decryptedStr.toString(CryptoJS.enc.Utf8);
};

export const setSessionVar = (key = "", data = undefined) => {
  if (key !== "" && data) {
    const encryptedData = encryptString({ str: JSON.stringify(data) });
    sessionStorage.setItem(key, encryptedData);
  }
};

export const getSessionVar = (key = "") => {
  if (key !== "") {
    const data = sessionStorage.getItem(key);
    if (data) {
      const decryptedData = JSON.parse(decryptString({ encryptedStr: data }));
      return decryptedData;
    } else {
      return undefined;
    }
  }
};
export const formatDateToDDMMYYYY = (dateString) => {
  const date = new Date(dateString);
  const day = String(date.getUTCDate()).padStart(2, "0");
  const month = String(date.getUTCMonth() + 1).padStart(2, "0");
  const year = date.getUTCFullYear();

  return `${year}-${month}-${day}`;
};

export const parseDateFromYYYYMMDD = (dateString) => {
  // Tách năm, tháng, ngày từ chuỗi YYYY-MM-DD
  const [year, month, day] = dateString.split("-").map(Number);
  // Tạo đối tượng Date (chú ý: tháng trong Date bắt đầu từ 0)
  return new Date(Date.UTC(year, month - 1, day));
};

export const convertStringToArray = (jsonString) => {
  try {
    // Kiểm tra xem chuỗi có rỗng hoặc không hợp lệ không
    if (!jsonString || typeof jsonString !== "string") {
      throw new Error("Input is not a valid string.");
    }

    // Parse chuỗi JSON thành mảng
    const parsedArray = JSON.parse(jsonString);

    // Loại bỏ null khỏi mảng
    const filteredArray = parsedArray.filter((item) => item !== null);

    return filteredArray;
  } catch (error) {
    return []; // Trả về mảng rỗng nếu xảy ra lỗi
  }
};

export const formatNumber = (num) => {
  return new Intl.NumberFormat("de-DE").format(num); // "de-DE" sử dụng dấu chấm làm dấu phân cách
};
